import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../app/store';
import { updateSelectedContract, clearValidationError } from '../../../../../services/ContractService/contractSlice';
import { useGetFinancialClassesQuery } from '../../../../../services/ContractService';

const FinancialClassEditor: React.FC = () => {
  const dispatch = useAppDispatch();
  const contract = useAppSelector((state) => state.contract.currentContract);
  const validationErrors = useAppSelector((state) => state.contract.validationErrors);
  const { data: financialClasses = [] } = useGetFinancialClassesQuery();

  const handleChange = (value: string) => {
    if (contract) {
      dispatch(updateSelectedContract({ financialClass: value }));
      if (validationErrors.financialClass) {
        dispatch(clearValidationError('financialClass'));
      }
    }
  };

  if (!contract) return null;

  return (
    <FormControl variant="outlined" size="small" error={!!validationErrors.financialClass} sx={{ width: 220 }}>
      <InputLabel>Financial Class *</InputLabel>
      <Select
        value={contract.financialClass}
        onChange={(e) => handleChange(e.target.value)}
        label="Financial Class *"
        sx={{ backgroundColor: 'white' }}
      >
        {financialClasses.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.name}
          </MenuItem>
        ))}
      </Select>
      {validationErrors.financialClass && (
        <FormHelperText>{validationErrors.financialClass}</FormHelperText>
      )}
    </FormControl>
  );
};

export default FinancialClassEditor;
